<template>
  <div>
    <sub-content-container :title="$t('myInterests.engineering.title')">
      <interest :interests="completeInterests" />
    </sub-content-container>
  </div>
</template>

<script>
const SubContentContainer = () =>
  import(
    /* webpackChunkName: "SubContentContainerComponent" */ "@/components/Global/SubContentContainer.vue"
  );
const Interest = () =>
  import(/* webpackChunkName: "MyInterestsPage" */ "@/components/MyInterests/Interest.vue");

export default {
  name: "Engineering",
  components: {
    SubContentContainer,
    Interest
  },
  data() {
    return {
      interests: [
        {
          image: "/img/interests/ruby-logo.png"
        },
        {
          image: "/img/interests/python-logo.png",
          backgroundColor: "black"
        },
        {
          image: "/img/interests/unity-logo.png"
        },
        {
          image: "/img/interests/blender-logo.png"
        },
        {
          icon: ["fas", "robot"],
          backgroundColor: "black"
        }
      ]
    };
  },
  computed: {
    completeInterests() {
      return this.interests.map((data, i) => ({
        ...data,
        ...this.$t("myInterests.engineering.interests")[i]
      }));
    }
  }
};
</script>
